import PdfEditor from "../PdfEditor/PdfEditor";

const Dashboard = () => {
  return <PdfEditor />;
};

export default Dashboard;
